// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"faq-pages_component_wrapper__CXSDo","main-card":"faq-pages_component_main-card__Ic9Wa","content":"faq-pages_component_content___92Z0"};